export const DEV_ENDPOINT = 'https://decormatters-dev.herokuapp.com/parse/functions/'
export const PROD_ENDPOINT = 'https://server.decormatters.com/parse/functions/'
